export const activesSelector = state => state.common.actives;

export const getActivesFetchStatusSelector = state => state.common.fetching.getActives;
